/**
 * Очередь повторной отправки сообщений (service worker + Background Sync).
 *
 * В `service-worker.ts` уже есть `BackgroundSyncPlugin` для
 * `POST /api/conversations/:id/messages`: если запрос не дошёл до сервера,
 * service worker кладёт его в IndexedDB и повторит сам, когда сеть
 * вернётся. Странице остаётся честно показать «в очереди» вместо
 * «не отправлено» — но только когда очередь действительно доступна.
 */

import { isNoResponseFailure } from './networkStatus';

/**
 * Доступна ли фоновая отправка: нужен активный service worker и
 * поддержка Background Sync (Chrome/Android; в Safari её нет).
 */
export const supportsBackgroundSync = (): boolean => {
    if (typeof navigator === 'undefined' || typeof window === 'undefined') {
        return false;
    }
    if (!('serviceWorker' in navigator)) return false;
    if (!('SyncManager' in window)) return false;
    const container = navigator.serviceWorker;
    return !!(container && container.controller);
};

/**
 * Можно ли не терять сообщение, а отдать его в очередь service worker.
 *
 * Подходит только сбой без ответа сервера: если сервер ответил 4xx/5xx,
 * повтор из очереди не поможет и пользователю нужна кнопка «Повторить».
 */
export const canQueueMessage = (error: unknown): boolean => {
    if (!isNoResponseFailure(error)) return false;
    return supportsBackgroundSync();
};
